import InstitutionSummaryTable from "./components/InstitutionSummaryTable";
import { useAuth } from "./contexts/authContext";
import { Button, CircularProgress, Grid, Typography } from "@mui/material";
import { argosApiEntryPoint } from "./GlobalConfig";
import { useEffect, useState } from "react";
import { auth } from "./firebase/firebase";
import { Item, percentage, round } from "./components/CommonComponents";

interface CountryMetrics {
    totalAnalysed: number,
    retractions: number,
    numberOfHighRiskArticles: number,
    numberOfMediumRiskArticles: number,
    numberOfLowRiskArticles: number
}


function CountryPage() {
    const { countryRoles } = useAuth()
    const countryCodeToName: { [key: string]: string } = {
        US: "United States",
        FR: "France",
        JP: "Japan",
        DE: "Germany",
        CN: "People's Republic of China",
        ES: "Spain",
        AE: "United Arab Emirates",
        SA: "Kingdom of Saudi Arabia"
    };

    const [totalAnalized, setTotalAnalized] = useState<number>(0)
    const [totalRetractions, setTotalRetractions] = useState<number>(0)
    const [highRiskArticles, setHighRiskArticles] = useState<number>(0)
    const [mediumRiskArticles, setMediumRiskArticles] = useState<number>(0)
    const [loading, setLoading] = useState<boolean>(false)

    useEffect(() => {

        async function fetchData() {
            let authToken = await auth.currentUser?.getIdToken(true)
            setLoading(true)

            fetch(argosApiEntryPoint + '/stats/country-summary?countryCode=' + countryRoles[0][0]
                , {
                    method: 'GET',
                    headers: {
                        'content-type': 'application/json;charset=UTF-8',
                        'Authorization': 'Bearer ' + authToken
                    }
                })
                .then((response) => response.json())
                .then((data: CountryMetrics) => {

                    let tRetractions = data.retractions
                    let tArticles = data.totalAnalysed;
                    setTotalRetractions(tRetractions);
                    setTotalAnalized(tArticles)
                    setHighRiskArticles(data.numberOfHighRiskArticles);
                    setMediumRiskArticles(data.numberOfMediumRiskArticles);
                    setLoading(false)
                })
        }
        fetchData()
    }, []);

    return <><Typography gutterBottom variant="h3" component="div" sx={{ color: '#003366', fontWeight: 'bold' }}>
        {countryCodeToName[countryRoles[0][0]]}'s Dashboard</Typography>
        <Grid container paddingTop={4} spacing={4}>
            <Grid item xs={12} sm={6} md={4}>
                <Item elevation={4}>
                    <Typography variant="h5" gutterBottom>Retractions since 2014</Typography>
                    {loading && <CircularProgress />}
                    {!loading && <>

                        <Button>
                            <Typography variant="h2" gutterBottom>{totalRetractions}</Typography>
                        </Button>

                        <Typography>The country retraction ratio is {percentage(totalRetractions, totalAnalized)}%. Based on the volume of articles {totalAnalized} and the average retraction ratio of 0.1078%, we would have expected {round(totalAnalized * 0.001078)} retractions.</Typography>
                    </>}
                </Item>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Item elevation={4}>
                    <Typography variant="h5" gutterBottom>High Risk Articles since 2014</Typography>
                    {loading && <CircularProgress />}
                    {!loading && <>

                        <Button>
                            <Typography variant="h2" gutterBottom>{highRiskArticles}</Typography>
                        </Button>

                        <Typography>The country high risk ratio is {percentage(highRiskArticles, totalAnalized)}%. Based on the volume of articles {totalAnalized} and the average high risk ratio of 0.1507%, we would have expected {round(totalAnalized * 0.001507)} high risk articles.</Typography>
                    </>}
                </Item>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <Item elevation={4}>
                    <Typography variant="h5" gutterBottom>Medium Risk Articles since 2014</Typography>
                    {loading && <CircularProgress />}
                    {!loading && <>
                        <Button>
                            <Typography variant="h2" gutterBottom>{mediumRiskArticles}</Typography>
                        </Button>
                        <Typography>The country medium risk ratio is  {percentage(mediumRiskArticles, totalAnalized)}%. Based on the volume of articles {totalAnalized} and the average medium risk ratio of 0.5572%, we would have expected {round(totalAnalized * 0.005572)} medium risk articles.</Typography>
                    </>}
                </Item>
            </Grid>
            <Grid item xs={12} sx={{alignItems: 'center'}}>
                <InstitutionSummaryTable countryCode={countryRoles[0][0]} />
            </Grid>
        </Grid>
    </>
}

export default CountryPage;